import { useState } from 'react'
import QuizTypeSelectInput from '../../../components/forms/QuizTypeSelectInput'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'
import ConfirmCreateQuizModal from '../../../components/modals/ConfirmCreateQuizModal'
import Button from '../../../components/ui/Button'
import { useQuizzes } from '../../../contexts/QuizContext'
import TextInput from '../../../components/forms/TextInput'

function QuizCreationForm({ topic, onSuccess=(newQuiz)=>{} }) {
  const { addQuiz } = useQuizzes(topic)
  const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm()
  const [showConfirm, setShowConfirm] = useState(false)
  const [pendingQuizData, setPendingQuizData] = useState(null)

  const onSubmitQuiz = async (data) => {
    if (!topic) {
      toast.error('Please select a topic to create a quiz under')
      return
    }
    // Save the data and open the confirm modal
    setPendingQuizData({ ...data, topic })
    setShowConfirm(true)
  }

  const handleConfirm = async () => {
    try {
      let newQuiz = await addQuiz({
        quiz_type: pendingQuizData.quiz_type,
        topic: pendingQuizData.topic,
        expected_duration: pendingQuizData.expected_duration ? `${pendingQuizData.expected_duration}:00` : null
      })
      toast.success('Quiz created successfully')
      reset()
      setPendingQuizData(null)
      setShowConfirm(false)
      onSuccess(newQuiz)
    } catch (error) {
      console.log(error)
      toast.error(error?.response?.data?.non_field_errors[0] || 'Failed to create quiz')
      setShowConfirm(false)
    }
  }

  const handleCancel = () => {
    setShowConfirm(false)
    setPendingQuizData(null)
  }

  return (
    <div className="mt-6 max-w-3xl bg-white p-4 rounded-lg">
      <form onSubmit={handleSubmit(onSubmitQuiz)}>
        <div className='flex gap-3 items-start'>
          <QuizTypeSelectInput
            name="quiz_type"
            register={register}
            errors={errors}
            helpText={'Select the type of quiz you want to create'}
            className={'flex-grow'}
          />
          <TextInput
            name={'expected_duration'}
            label={'Duration (minutes)'}
            type="number"
            placeholder="e.g. 30"
            errors={errors}
            register={register}
            validationRules={{}}
            min={1}
          />
        </div>
        <Button className='mb-7 self-end' type="submit" isLoading={isSubmitting}>
          Create Quiz
        </Button>
      </form>
      {showConfirm && (
        <ConfirmCreateQuizModal
          show={showConfirm}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          quiz_type={pendingQuizData.quiz_type}
          topic_id={pendingQuizData.topic}
          expected_duration={pendingQuizData.expected_duration}
        />
      )}
    </div>
  )
}

export default QuizCreationForm;